module.exports = __webpack_public_path__ + "static/media/CloudDownload.55ae5742.svg";